module.exports = __webpack_public_path__ + "img/111.03fbf0c8.png";